
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6DA544","d":"M512 426.666V85.329H0v341.337h512z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M512 85.331H0v170.666h512V85.331z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 85.334h181.793v341.337H0z"}})])
          )
        }
      }
    